import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { AmountFormatted } from '@root/shared/core/format'

import type { CurrencyModel } from '@root/entities/currency'
import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type Props = {
  balance: BigNumber
  currency: CurrencyModel
} & ClassNameProps

export const TransferAmountBalance: React.FC<Props> = ({
  balance,
  currency,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <Root className={className}>
      <BalanceText>{t('common.balance')}: </BalanceText>
      <BalanceAmount>
        <AmountFormatted
          amount={balance}
          currency={currency.ticker}
          roundingMode="trunc"
        />
      </BalanceAmount>
    </Root>
  )
}

const Root = styled.div`
  font-size: 10px;
  font-weight: 600;
  line-height: 11px;
`

const BalanceText = styled.span`
  color: var(--text-7);
`

const BalanceAmount = styled.span`
  color: var(--text-10);
`
